var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.773 12.01 2l9.986 5.773V19.32l-4.014 2.33-2.973-1.735 4.013-2.304V9.484L12.01 5.444l-7.037 4.04v8.127l4.04 2.33-.546.322L6.04 21.65l-4.04-2.33V7.773zm21.508 4.312 2.973-1.735 4.04 2.33v11.546L20.51 30 10.5 24.226V12.68l4.038-2.33 2.428 1.388.57.322-4.039 2.33v8.102l7.013 4.064 7.012-4.064V14.39l-4.014-2.305z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcn);
export default __webpack_public_path__ + "static/media/XCN.735e5c82499d5fdf48783452c49d9e1b.svg";
export { ForwardRef as ReactComponent };